import { FC, useState } from 'react'
import { getListNoShowService, cancelNoShowReserveService } from '../../../../services/booking.service'
import { getSnackBarToast } from '../../../../../../util/snackBar'
import { ModalListNoShow } from '../Modals/ModalListNoShow'
import { KTCard } from '../../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components/UI/Button'
import Swal from 'sweetalert2'

const FormCancelReservations: FC = () => {
  const [showModalList, setShowModalList] = useState(false)
  const [totalsData, setTotalsData] = useState<{
    TotalReservasCamaEnEstadoAsignado: number
    TotalReservasCamaEnEstadoGenerado: number
    TotalReservasCamaAEliminar: number
  } | null>(null)
  const [loading, setLoading] = useState(false)

  const handleGetList = async () => {
    try {
      setLoading(true)
      const response = await getListNoShowService()

      if (!response.data.error) {
        const totalAsignado = response.data.TotalReservasCamaEnEstadoAsignado || 0
        const totalGenerado = response.data.TotalReservasCamaEnEstadoGenerado || 0
        const totalAEliminar = response.data.TotalReservasCamaAEliminar || 0

        if (totalAsignado > 0 || totalGenerado > 0) {
          setTotalsData({
            TotalReservasCamaEnEstadoAsignado: totalAsignado,
            TotalReservasCamaEnEstadoGenerado: totalGenerado,
            TotalReservasCamaAEliminar: totalAEliminar,
          })
          setShowModalList(true)
        } else {
          getSnackBarToast('No hay reservas por cancelar', 'info')
        }
      } else {
        getSnackBarToast(response.data.message || 'Error al obtener las reservas', 'error')
      }
    } catch (error) {
      getSnackBarToast('Hubo un error al obtener las reservas', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleAccept = () => {
    Swal.fire({
      title: '¿Estás seguro de cancelar las reservas camas a eliminar?',
      text: 'Esta acción cancelará las reservas camas a eliminar',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await cancelNoShowReserveService()
          if (!response.data.error) {
            return true
          } else {
            Swal.showValidationMessage(response.data.message || 'Error al cancelar las reservas')
            return false
          }
        } catch (error) {
          Swal.showValidationMessage('Hubo un error al cancelar las reservas')
          return false
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        getSnackBarToast('Se han cancelado satisfactoriamente las reservas camas', 'success')
        setShowModalList(false)
        setTotalsData(null)
        Swal.close()
      }
    })
  }

  return (
    <>
      <KTCard>
        <div className='d-flex justify-content-center align-items-center p-10'>
          <Button
            onClick={handleGetList}
            label='Consultar Reservas a Cancelar'
            loading={loading}
            disabled={loading}
          />
        </div>
      </KTCard>
      {showModalList && (
        <ModalListNoShow
          show={showModalList}
          setShow={setShowModalList}
          totalsData={totalsData}
          onAccept={handleAccept}
        />
      )}
    </>
  )
}

export { FormCancelReservations }
